import React from "react";

const PimsIcon = ({ size = 24, isActive = false, noPermission = false }) => {
  const fill = noPermission
    ? isActive
      ? "#8b939e"
      : "#c5ccd6"
    : isActive
      ? "#588cc7"
      : "white";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7.2 19.2C5.88 19.2 4.812 20.28 4.812 21.6C4.812 22.92 5.88 24 7.2 24C8.52 24 9.6 22.92 9.6 21.6C9.6 20.28 8.52 19.2 7.2 19.2ZM19.2 19.2C17.88 19.2 16.812 20.28 16.812 21.6C16.812 22.92 17.88 24 19.2 24C20.52 24 21.6 22.92 21.6 21.6C21.6 20.28 20.52 19.2 19.2 19.2ZM8.52 13.2H17.46C18.36 13.2 19.152 12.708 19.56 11.964L24 3.552L21.9 2.4L17.46 10.8H9.036L3.924 0H0V2.4H2.4L6.72 11.508L5.1 14.436C4.224 16.044 5.376 18 7.2 18H21.6V15.6H7.2L8.52 13.2ZM13.2 0L18 4.8L13.2 9.6L11.508 7.908L13.404 6H8.4V3.6H13.404L11.496 1.692L13.2 0Z"
        fill={fill}
      />
    </svg>
  );
};

export default PimsIcon;